import React from 'react';
import { useNavigate } from 'react-router-dom';
import UserRoleForm from '../components/UserRoleForm';

const  UserRoleTest = () => {
  const navigate = useNavigate();

  const handleRoleSubmit = (selectedRole) => {
    alert(`Role selected: ${selectedRole}`);
    // For testing purposes, navigate to the workspace route which will handle role-based routing
    if (selectedRole === 'freelancer' || selectedRole === 'student' || selectedRole === 'content_creator' || selectedRole === 'influencer' || selectedRole === 'entrepreneur') {
      // Set the role in localStorage for testing
      localStorage.setItem('testRole', selectedRole);
      navigate('/workspace');
    } else {
      navigate('/profile');
    }
  };

  return (
    <div id='Test' style={{ padding: '20px' }}>
      <h1>UserRoleForm Test Page</h1>
      <p>This page allows you to test the UserRoleForm component without making a payment.</p>
      <UserRoleForm onSubmit={handleRoleSubmit} user={{ name: 'Test User' }} />
    </div>
  );
};

export default UserRoleTest;
